import * as Yup from "yup";

// Validation for the "Land hinzufügen" form. The messages come from t().
export const buildCountryOptionSchema = (t) => {
  const countrySchema = Yup.object({
    isoCode: Yup.string().required(t("countries.errors.countryRequired")),
    dialCode: Yup.string()
      .required(t("countries.errors.dialCodeRequired"))
      .matches(/^\+\d{1,4}$/, t("countries.errors.dialCodeFormat")),
    digits: Yup.array()
      .of(
        Yup.number()
          .typeError(t("countries.errors.digitsFormat"))
          .integer(t("countries.errors.digitsFormat"))
          .min(3, t("countries.errors.digitsFormat"))
          .max(10, t("countries.errors.digitsFormat"))
      )
      .min(1, t("countries.errors.digitsRequired"))
  });
  return Yup.object({
    name: Yup.string().trim().required(t("countries.errors.nameRequired")),
    countries: Yup.array()
      .of(countrySchema)
      .min(1, t("countries.errors.countryRequired")),
    mapImage: Yup.object()
      .nullable()
      .required(t("countries.errors.mapRequired"))
  });
};
